









import Vue from 'vue';
import Store from '@/services/Store';
import MainArea from '@/components/MainArea.vue';
import ImageArea from '@/components/ImageArea.vue';
import TextArea from '@/components/TextArea.vue';
import { Piano, fId } from '@/services/Utility';

export default Vue.extend({
	name: 'QuizFeedback',
	props: {
		selectedAnswer: String,
	},
	mounted() {
		let status = this._isAnswerCorrect() ? 'korrekt' : Store.quizState.isTippGiven() ? 'tipp' : 'falsch';
		let t = Store.quizState.getQuizTitle().match(/(\w+)/g);
		let title = t !== null ? `__${t[0]}${typeof t[1] !== 'undefined' ? `_${t[1]}` : ''}` : '';
		Piano({t:'page.display', p:{inhaltstyp:title, seitenname_id:`feedbackPage_${status}`, seitentitel: `Frage: ${this.getCurrentQuestionText().substr(0, 30)}...`}})
		window.setTimeout(() => {
			let prms = { status: 200, h: this.$root.$el.clientHeight, tgt: fId };
			// console.log(`QuizFeedback: will post ${JSON.stringify(prms)}`);
			if (window.self !== window.top) {
				parent.postMessage(prms, 'https://www.br.de');
			}
		}, 500);
	},
	methods: {
		getCurrentQuestionText() {
			return Store.quizState.getCurrentQuestionText();
		},
		getCurrentQuestionImage() {
			return Store.quizState.getCurrentQuestionImage();
		},
		getRandomTransition() {
			return this._isAnswerCorrect() ? Store.quizState.getRandomTransitionRight().text : Store.quizState.getRandomTransitionWrong().text;
		},
		getCurrentFeedback() {
			if (this._isAnswerCorrect()) {
				return Store.quizState.getCurrentSolvedText();
			} else if (Store.quizState.isTippGiven()) {
				return Store.quizState.getCurrentNotSolvedText();
			} else {
				return Store.quizState.getCurrentTippText();
			}
		},
		getNextBtnHtml() {
			return this._shouldMoveOn() ? 'Weiter' : 'Nochmal versuchen ...';
		},
		handleNextClick() {
			Piano({t:'click.navigation', p:{click:'btnNext', click_chapter1:'navigationButton'}});
			// Set increased score if the answer was correct
			if (this._isAnswerCorrect()) Store.quizState.setIncreasedScore();
			// Repeat question, go to next question or show results
			if (this._shouldShowSameQuestion()) {
				Store.quizState.setTippGiven();
				this.$router.push({ name: 'QuizQuestion', params: { quiz: 'play', selectedAnswer: this.selectedAnswer } });
			} else if (this._shouldMoveToNextQuestion()) {
				this.$router.push({ name: 'QuizQuestion', params: { quiz: 'play' } });
			} else {
				// should show results!
				this.$router.push({
					name: 'QuizResults',
					params: {
						score: Store.quizState.getScoreInPercent().toString(),
					},
				});
			}
		},
		_isAnswerCorrect() {
			return Store.quizState.getCorrectAnswers().includes(this.selectedAnswer);
		},
		_shouldShowSameQuestion() {
			return !this._isAnswerCorrect() && !Store.quizState.isTippGiven();
		},
		_shouldMoveToNextQuestion() {
			return Store.quizState.setNextQuestion();
		},
		_shouldMoveOn() {
			return this._isAnswerCorrect() || Store.quizState.isTippGiven();
		},
	},
	components: {
		MainArea,
		ImageArea,
		TextArea,
	},
	beforeRouteEnter(to, from, next) {
		if (to.params.selectedAnswer == undefined) next({ name: 'QuizIntro' });
		else next();
	},
});
